module.exports = __webpack_public_path__ + "img/icon_success@3x.fce99022.png";